// extracted by mini-css-extract-plugin
export default {"main":"UnavailablePage_main__RCAe0","body":"UnavailablePage_body__1aCor","heading":"UnavailablePage_heading__AGZVS","text":"UnavailablePage_text__qzJrG"};